module.exports = {
    'Init': require('./init'),
    'DidNavigate': require('./did-navigate')
};